<script setup lang="ts">
import {DraftingCompass, Handshake, Lightbulb, SearchCheck, Settings2} from 'lucide-vue-next';
import SectionHeading from './SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();
const steps = [
  {icon: SearchCheck, ar: 'دراسة وتخطيط', en: 'Study & planning', arText: 'فهم المتطلبات وتحديد النطاق والمخاطر.', enText: 'Understand requirements, scope and risk.'},
  {icon: DraftingCompass, ar: 'حلول هندسية', en: 'Engineering', arText: 'تصميم قابل للتنفيذ وبدائل عملية.', enText: 'Buildable design and practical options.'},
  {icon: Settings2, ar: 'تنفيذ ورقابة', en: 'Execution', arText: 'إدارة الجودة والتكلفة والبرنامج الزمني.', enText: 'Control quality, cost and schedule.'},
  {icon: Handshake, ar: 'تسليم ودعم', en: 'Handover', arText: 'تسليم منظم ومتابعة ما بعد الإنجاز.', enText: 'Structured handover and post-delivery support.'},
  {icon: Lightbulb, ar: 'تطوير مستمر', en: 'Continuous improvement', arText: 'تعلم من البيانات وتحسين الأداء.', enText: 'Use data and lessons learned to improve.'},
];
</script>

<template>
  <section id="projects" class="section section--bordered workflow-section">
    <div class="container">
      <SectionHeading :eyebrow="isArabic ? 'منهجية العمل' : 'How we work'" :title="isArabic ? 'من الفكرة إلى الإنجاز باحترافية' : 'From idea to professional delivery'" />
      <div class="workflow-grid">
        <article v-for="(step, index) in steps" :key="step.en" class="workflow-card reveal">
          <span class="workflow-card__number">0{{ index + 1 }}</span>
          <span class="icon-box"><component :is="step.icon" :size="28" /></span>
          <h3>{{ isArabic ? step.ar : step.en }}</h3>
          <p>{{ isArabic ? step.arText : step.enText }}</p>
        </article>
      </div>
      <div class="quality-banner">
        <div><span class="eyebrow">{{ isArabic ? 'التزامنا' : 'Our commitment' }}</span><h3>{{ isArabic ? 'الجودة والسلامة ليستا مرحلة، بل نظام عمل.' : 'Quality and safety are not a phase; they are our operating system.' }}</h3></div>
        <p>{{ isArabic ? 'نطبق إجراءات واضحة للتفتيش والتوثيق وإدارة المخاطر، بما يحافظ على الأفراد والممتلكات وجودة المخرجات.' : 'Clear inspection, documentation and risk-control procedures protect people, assets and the final result.' }}</p>
      </div>
    </div>
  </section>
</template>
